// components/common/Modal.tsx
import React from "react";
import styles from "./Modal.module.css";



export default function Modal({ isOpen, onClose, children, contentStyle }) {
    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div
                className={styles.content}
                style={contentStyle}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
                <button className={styles.closeBtn} onClick={onClose}>
                    확인
                </button>
            </div>
        </div>
    );
}
